module.exports = __webpack_public_path__ + "static/img/99-3.c30c181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/99-3.jpg
// module id = zqQp
// module chunks = 0